<template>
	<div>
		<section class="hero-wrap js-fullheight"  data-stellar-background-ratio="0.5">
			<div class="overlay">
				<img src="@/assets/images/bg_2.jpg" class="hero-wrap-img" importance="high" @load="imgLoad()" style="min-width: 1920px;"/>
			</div>
			<div class="container">
				<div class="row no-gutters slider-text js-fullheight align-items-center justify-content-center" data-scrollax-parent="true">
					<div class="col-lg-9  text-center">
						<div class="mt-5">
							<h1 class="mb-4" >山东孚岳电气有限公司</h1>
							<!-- <p class="mb-4" style="font-size: 28px;">
								领先、安全、自主、可控,做精做实核心技术，主力推进电力工业
							</p> -->
							<div style="font-size: 28px;">领先 安全 自主 可控</div>
							<div style="font-size: 28px;">做精做实核心技术，主力推进数字产业</div>
							<p style="margin-top: 20px;"><a href="#" class="btn btn-primary" @click="jumpIndexFun('2')">查看详情</a> </p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="ftco-section bg-light">
			<div class="container-index-list">
				<div class="row justify-content-center mb-5 pb-3">
					<div class="col-md-10 heading-section text-center ">
						<span class="subheading">产品服务</span>
						<h2 class="mb-4">我们的产品服务</h2>
					</div>
				</div>
				<div class="row d-flex">
					<div class="col-lg-3 " v-for="(item, index) in productList" :key="index">
						<div class="blog-entry">
							<a class="block-20 index-top-img" >
								<img :src="$urlData + '/prod-api' + item.picThumbnailUrl" alt="" style="width: 100%;" :loading="imgLoading">
							</a>
							<div class="text d-block">
								<h3 class="heading"><a >{{ item.title }}</a></h3>
								<p class="index-list-span">{{ item.blurb }}</p>
								<p><a @click="jumpFun(item.id)" class="btn btn-secondary py-2 px-3">了解更多</a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<section class="ftco-section testimony-section img" style="background-image: url(images/bg_1.jpg);">
			<div class="overlay"></div>
			<div class="container-index-list">
				<div class="row justify-content-center mb-5 pb-3">
					<div class="col-md-7 text-center heading-section heading-section-white ">
						<h2 class="mb-4">企业荣誉</h2>
					</div>
				</div>
				<div class="container-index-list">
					<div class=" honor_list">
						<div class="clearfix row d-flex justify-content-xl-between" style="color: #fff;" >
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2014-2015年 连续两年在淄博市 “初创企业”奖项
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2014年10月荣获国网山东省电力公司检修公司优秀供应商称号
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2015年11月顺利通过ISO9000质量管理体系认证
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2017年通过国家级高新技术企业认定
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2017年荣获淄博市“三个一百”项目重点扶持企业之一
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" >
										2018年通过了国家级高新技术企业认定
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2018年获得住建部认定的电力总承包、安全设计标准等资质
									</div>
									<div>
										<img src="@/assets/images/certificate.png" >
										2019年任崇广总经理荣获山东省泰山系列人才称号
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" />
										2020年获得山东半岛自创区优秀企业称号
									</div>
									
									<div>
										<img src="@/assets/images/certificate.png" />
										2020年获得淄博市瞪羚培育企业称号
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2021年成为山东理工大学"科技副总"人才战略项目重点合作单位
									</div>
								</div>
							</div>
							<div class="col-lg-55 mb-4">
								<div class="honorimg">
									<div>
										<img src="@/assets/images/certificate.png" />
										2022年与山东理工大学共同设立研究生联合培养基地
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2023年获得山东省专精特新企业
									</div>
									<div>
										<img src="@/assets/images/certificate.png" />
										2024年获批山东省科技型中小企业创新能力提升工程项目
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row  justify-content-center">
				</div>
			</div>
		</section>
		
		<div class="AboutUs-honor" style="padding-bottom: 10rem;">
			<div class="AboutUs-blurb-title">
				<span>部分合作客户</span>
			</div>
			<div class="AboutUs-blurb-title-text">我们一路同行，一起成长；未来、我们一同见证、一起分享、更显珍贵。</div>
			<div >
				<div class="customer_list">
					<div class="clearfix row d-flex">
						<div v-for="(item, index) in cooperationArr" :key="index" class="col-lg-2 cooperation-list">
							<div class="cooperation-div">
								<img :src="'/prod-api' + item.picUrl" alt="" :loading="imgLoading">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	data() {
		return {
			imgLoading: 'lazy',
			activeIndex: '1',
			displayIf: '1',
			staffData: [],
			productList: [],
			basicsData: '',
			cooperationArr: []
		};
	},
	created() {
		// 员工
		this.staffFun()
		// 产品
		this.productFun()
		// 基础信息
		this.basicsFun()
		// 部分合作客户
		this.cooperationFun()
	},
	methods: {
		imgLoad() {
			this.imgLoading = 'eager'
		},
		// 部分合作客户
		cooperationFun() {
			let url = this.$urlData + '/prod-api/system/customer/list?pageNum=1&pageSize=9999'
			axios.get(url)
				.then(response => {
					this.cooperationArr =  response.data.rows;
				})
				.catch(error => {
					console.error('There was an error!', error);
				});
		},
		// 基础信息
		basicsFun() {
			let url = this.$urlData + '/prod-api/system/basic/list?pageNum=1&pageSize=1'
			axios.get(url)
				.then(response => {
					this.basicsData =  response.data.rows[0];
				})
				.catch(error => {
					console.error('There was an error!', error);
				});
		},
		// 产品
		productFun() {
			let url = this.$urlData + '/prod-api/home/product/list?pageNum=1&pageSize=4&isshow=1'
			axios.get(url)
				.then(response => {
					this.productList =  response.data.rows;
				})
				.catch(error => {
					console.error('There was an error!', error);
				});
		},
		// 员工
		staffFun() {
			let url = this.$urlData + '/prod-api/home/grace/list?pageNum=1&pageSize=9999'
			axios.get(url)
				.then(response => {
					let staffArr = response.data.rows;
					
					this.staffData = this.chunkArray(staffArr, 3);
				})
				.catch(error => {
					console.error('There was an error!', error);
				});
		},
		// 分割数组
		chunkArray(arr, chunkSize) {
			let groups = [];
			for (let i = 0; i < arr.length; i += chunkSize) {
				groups.push(arr.slice(i, i + chunkSize));
			}
			return groups;
		},
		jumpFun(data) {
			console.log(data)
			let jsonData = {
				id: data,
				num: '4-1-1'
			}
			this.$emit('jumpFun', jsonData)
		},
		jumpIndexFun() {
			let jsonData = {
				id: '',
				num: '2'
			}
			this.$emit('jumpFun', jsonData)
		}
	}
}
</script>

<style scoped>

</style>
